/* CAMPAIGN STATUSES DATA */
export const GET_CAMPAIGN_STATUSES = "GET_CAMPAIGN_STATUSES"
export const SET_CAMPAIGN_STATUSES = "SET_CAMPAIGN_STATUSES"

/* CAMPAIGNS STATUSES ACTIONS */
export const ADD_CAMPAIGN_STATUS = "ADD_CAMPAIGN_STATUS"
export const DELETE_CAMPAIGN_STATUS = "DELETE_CAMPAIGN_STATUS"

/* CAMPAIGN FORMAT PROFILE DATA */
export const GET_CAMPAIGN_STATUS_PROFILE = "GET_CAMPAIGN_STATUS_PROFILE"
export const SET_CAMPAIGN_STATUS_PROFILE = "SET_CAMPAIGN_STATUS_PROFILE"
export const UPDATE_CAMPAIGN_STATUS_PROFILE = "UPDATE_CAMPAIGN_STATUS_PROFILE"
export const SET_ERROR_CAMPAIGN_STATUS_PROFILE = "SET_ERROR_CAMPAIGN_STATUS_PROFILE"

/* LOADER */
export const SHOW_CAMPAIGN_STATUSES_LOADER = "SHOW_CAMPAIGN_STATUSES_LOADER"
export const HIDE_CAMPAIGN_STATUSES_LOADER = "HIDE_CAMPAIGN_STATUSES_LOADER"
